import { expectedFromResult } from './expected'

// Criterion #8: walk the RENDERED display tree (real PixiJS on the phones, a
// stand-in in Jest) and compare every scene sprite with what the rules
// module's output says should be there: same set of things (structures,
// craters, stamps, Broods, eggs, rockets, scans, cells), same state, same
// position. Scene sprites carry `gate1 = { key, state }`.
export function collectRendered(root) {
    const out = new Map()
    const dupes = []
    const walk = (node, ox, oy) => {
        const x = ox + (node.position?.x ?? node.x ?? 0)
        const y = oy + (node.position?.y ?? node.y ?? 0)
        if (node.gate1) {
            if (out.has(node.gate1.key)) dupes.push(node.gate1.key)
            out.set(node.gate1.key, { state: node.gate1.state, x, y, visible: node.visible !== false })
        }
        for (const c of node.children ?? []) walk(c, x, y)
    }
    walk(root, -(root.position?.x ?? 0), -(root.position?.y ?? 0)) // board coordinates
    return { rendered: out, dupes }
}

export function verifyScene(root, result, R, { tolerance = 0.01 } = {}) {
    const want = expectedFromResult(result, R)
    const { rendered, dupes } = collectRendered(root)
    const missing = [], extra = [], wrongState = [], wrongPos = [], hidden = []
    for (const [key, w] of want) {
        const r = rendered.get(key)
        if (!r) { missing.push(key); continue }
        if (r.state !== w.state) wrongState.push(`${key}: rendered "${r.state}", module "${w.state}"`)
        if (Math.abs(r.x - w.x) > tolerance || Math.abs(r.y - w.y) > tolerance) wrongPos.push(`${key}: (${r.x.toFixed(2)}, ${r.y.toFixed(2)}) vs (${w.x.toFixed(2)}, ${w.y.toFixed(2)})`)
        if (!r.visible) hidden.push(key)
    }
    for (const key of rendered.keys()) if (!want.has(key)) extra.push(key)
    const counts = {}
    for (const key of want.keys()) { const k = key.split(':')[0]; counts[k] = (counts[k] ?? 0) + 1 }
    const pass = !missing.length && !extra.length && !wrongState.length && !wrongPos.length && !hidden.length && !dupes.length
    return { pass, expected: want.size, rendered: rendered.size, counts, missing, extra, wrongState, wrongPos, hidden, dupes }
}
